module.exports = __webpack_public_path__ + "static/media/playnowtext.1427161c.png";